/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { NB_AUTH_OPTIONS } from '@nebular/auth/auth.options';
import {getDeepFromObject} from '@nebular/auth/helpers';
import {TranslateService} from '@ngx-translate/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AUTH_CONFIG } from '../../../../configs/auth.config';

import { NbAuthResult, NbAuthService } from '@nebular/auth';

import { ActionService } from '../../../../@core/data/action.service';
import { LogoService } from '../../../../@core/services/logo.service';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
})
export class NgxLoginComponent implements OnInit {
  logo: string;
  redirectDelay = 0;
  showMessages: any = {};
  strategy = '';
  currentLang = 'es';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted = false;

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected config = {},
    protected router: Router,
    protected translate: TranslateService,
    private http: HttpClient,
    private actionService: ActionService,
    private logoService: LogoService,
  ) {
    this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
    this.showMessages = this.getConfigValue('forms.login.showMessages');
    this.strategy = this.getConfigValue('forms.login.strategy');
    console.log(this.strategy, this.showMessages, this.redirectDelay, this.config)
    this.translate.onLangChange.subscribe((event: any) => {
      this.currentLang = event.lang;
    });
  }

  ngOnInit(): void {
    this.logoService.getLogo().subscribe(logo => {
      this.logo = logo;
    });
    this.changeLanguage('es');
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
  }

  login(): void {
    this.errors = this.messages = [];
    this.submitted = true;

    this.service
      .authenticate(this.strategy, this.user)
      .subscribe((result: NbAuthResult) => {
        this.submitted = false;

        if (result.isSuccess()) {
          sessionStorage.clear()
          this.actionService.createAction({action: 'login'})
          this.messages = result.getMessages();
        } else {
          this.errors = result.getErrors();
        }

        const redirect = result.getRedirect();
        try {
          if (redirect) {
            setTimeout(() => {
              return this.router.navigateByUrl(redirect);
            }, this.redirectDelay);
          }
        } catch (e) {
          console.log(e);
        }
      });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(AUTH_CONFIG, key, null);
  }
}
